import "../styles/index.scss";
import AltarApp from "./AltarApp";

window.addEventListener("load", async () => {
  const altar = new AltarApp();
  altar.init();
});